<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { getCurrentInstance, onMounted } from 'vue';

import CartDetails from '@/components/cart/v2/CartDetails.vue';
import { i18n } from '@/shared-instance.ts';
import { useGlobalConfigurationStore } from '@/stores/useGlobalConfigurationStore.ts';

i18n.install(getCurrentInstance()!.appContext.app);

const configurationStore = useGlobalConfigurationStore();
const { globalConfiguration } = storeToRefs(configurationStore);

onMounted(() => {
  if (!globalConfiguration.value?.apikey) {
    throw new Error('api-key for cart-details component is missing');
  }
});
</script>

<template>
  <CartDetails />
</template>
